import type { PaywallCoupon } from "./PaywallCoupon";

export const paywallCouponRedemptionStatuses = {
  active: "active",
  ended: "ended",
  incomplete: "incomplete",
} as const;
export type PaywallCouponRedemptionStatus =
  keyof typeof paywallCouponRedemptionStatuses;

export interface PaywallCouponRedemption {
  community_member_subscription_id: number;
  id: number;
  paywall_coupon: PaywallCoupon;
  paywall_coupon_id: number;
  status: PaywallCouponRedemptionStatus;
}
